export enum ROLE {
  Tapu = 'TAPU',
  User = 'USER',
}